const DATA_IMAGE_BASE64_RE = /^data:image\/(png|gif|webp|svg\+xml);base64,[a-z0-9+/]+=*$/i;

export function setText(el, value) {
  if (!el) return;
  el.textContent = String(value ?? '');
}

export function sanitizeImageUrl(url, { allowDataImage = false } = {}) {
  if (typeof url !== 'string') return null;
  const value = url.trim();
  if (!value) return null;

  if (allowDataImage && DATA_IMAGE_BASE64_RE.test(value)) {
    return value;
  }

  try {
    const parsed = new URL(value, window.location.href);
    if (parsed.protocol !== 'https:') return null;
    return parsed.href;
  } catch {
    return null;
  }
}

export function createWalletIcon({ src, alt = '', width = 20, height = 20 } = {}) {
  const safeSrc = sanitizeImageUrl(src, { allowDataImage: true });
  if (!safeSrc) return null;

  const img = document.createElement('img');
  img.setAttribute('src', safeSrc);
  img.setAttribute('alt', String(alt ?? ''));
  img.setAttribute('width', String(width));
  img.setAttribute('height', String(height));
  return img;
}
